import React from "react";
import { useLocation } from 'react-router-dom'
import routes from '../overrides/routes'

export default function DashboardTitle() {

  const location = useLocation();

  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <div className="page-title-right">

          </div>

          {location.pathname == '/' ?
            <h4 className="page-title">Dashboard</h4> :

            <nav aria-label="breadcrumb">
              <ol class="breadcrumb bg-light-lighten p-2">
                <li class="breadcrumb-item"><a href="/"><i class="uil-home-alt"></i> Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">{location.pathname}</li>
              </ol>
            </nav>
          }

        </div>
      </div>
    </div>
  );
}